import Image from 'next/image'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {clsx} from 'clsx'
import {
	Icon as CIcon,
	type IconSize,
} from '@/_new-code/products/flexible-web-toolkit/components/icon'
import {loadImageFromKontentAI} from '@/imageLoader'
import type {IconWithTextContentItem} from '@/_new-code/products/flexible-web-toolkit/blocks/icon-with-text'
import type {Block} from '@/_new-code/services/kontent-ai/types'
import {RichTextRenderer} from '@/_new-code/products/flexible-web-toolkit/components/rich-text-renderer'
import {Card as ClBrandTableCard} from '@/_new-code/products/flexible-web-toolkit/components/card/index'
import {customBrands, customBrandChoices} from '../helpers'

export type BrandCardContentItem = IContentItem<{
	iconsWithText: Elements.LinkedItemsElement<IconWithTextContentItem>
}>

export const BrandTableCardBlock: Block<BrandCardContentItem> = ({
	block,
	...context
}) => {
	return (
		<ClBrandTableCard
			className="h-full py-6"
			data-kontent-element-codename="brand_card"
		>
			{block.elements.iconsWithText.map((icon) => (
				<div
					className="flex items-start pb-5 text-black last:pb-0"
					key={icon.system.id}
					role="listitem"
				>
					<CIcon
						brand={
							icon.elements.brand[0] &&
							customBrandChoices.includes(
								icon.elements.brand[0].codename
							)
								? 'none'
								: icon.elements.brand[0]?.codename || 'none'
						}
						iconCustomClasses={clsx(
							'p-1',
							icon.elements.brand[0] &&
								customBrandChoices.includes(
									icon.elements.brand[0]?.codename
								)
								? customBrands[icon.elements.brand[0].codename]
										?.border
								: ''
						)}
						noBorder
						size={
							(icon.elements.iconSize[0]?.codename ||
								'xs') as IconSize
						}
					>
						<div className="relative h-full w-full object-contain">
							{icon.elements.icon[0] ? (
								<Image
									alt={
										icon.elements.icon[0].description ?? ''
									}
									data-kontent-element-codename="icon"
									fill
									loader={loadImageFromKontentAI}
									src={icon.elements.icon[0].url}
								/>
							) : null}
						</div>
					</CIcon>

					<div className="content ml-4">
						<strong>{icon.elements.title}</strong>
						<RichTextRenderer
							element={icon.elements.description}
							{...context}
						/>
					</div>
				</div>
			))}
		</ClBrandTableCard>
	)
}
